// extracted by mini-css-extract-plugin
export default {"search":"HeaderSearchBlock_search__eTmcl","searchLineExpanded":"HeaderSearchBlock_searchLineExpanded__OM-F9"};